import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CustomDelete, FullTable } from 'components';
import {
    DELETE_GENERAL_REPORT,
    GENERAL_REPORT_ACTION_TYPE,
    GeneralReportNotYet,
    GeneralReportsBody,
    GeneralReportsHead,
} from './constants';
import { reportActions } from 'store';
import { globalSessionENums, token, useModal } from 'utils';
import axios from 'axios';

export const GeneralReports = ({}) => {
    const { therapySession } = useSelector((state) => ({
        therapySession: state.auth.therapySessionEvents?.[globalSessionENums.REPORT_GENERATION],
    }));
    const dispatch = useDispatch();
    const generalReports = useSelector((state) => state.reports.generalReports);
    const { open } = useModal();
    const [load, setLoadDownload] = useState(false);
    const reportSession = therapySession?.evenType === globalSessionENums.REPORT_GENERATION && therapySession?.data;

    const getGeneralReports = (load) => {
        dispatch(reportActions.getGeneralReports({ skip: 0, limit: 30 }, load));
    };

    useEffect(() => {
        getGeneralReports();
    }, [dispatch, reportSession]);

    const openDelete = (item) => {
        open(
            <CustomDelete
                text="Are you sure you want to delete this report? This action is not reversible."
                info="Delete Report"
                handleDel={() => dispatch(reportActions.deleteGeneralReports(item?.id))}
                actionType={DELETE_GENERAL_REPORT}
                innerText={'Delete'}
            />
        );
    };

    const handleDownload = async (item) => {
        setLoadDownload(item?.id);
        try {
            const response = await axios({
                url: `/reports/download/${item?.id}`,
                method: 'POST',
                // responseType: 'blob',
                headers: { 'access-token': `${token()}` },
            });
            setLoadDownload(null);
            getGeneralReports('noLoad');
            // const url = window.URL.createObjectURL(new Blob([response.data]));
            const url = response.data;
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${item?.file?.originalName}${item?.file?.format ? item?.file?.format : ''}`);
            link.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
        } catch (e) {
            setLoadDownload(null);
        }
    };

    return (
        <div>
            <FullTable
                head={GeneralReportsHead()}
                body={GeneralReportsBody(openDelete, handleDownload, load)}
                loadingType={GENERAL_REPORT_ACTION_TYPE}
                list={generalReports}
                notYet={GeneralReportNotYet}
                activeRowId={''}
                margin={'0'}
            />
        </div>
    );
};
